// @ts-ignore
import {Pagination, Navigation, SwiperClass} from 'swiper';
// @ts-ignore
import {Swiper, SwiperSlide} from 'swiper/react';
import {useEffect, useState} from 'react';
import sanityConfig from '../../../sanity.config';
import SanityImage from '../media/SanityImage.client';
import {SanityAsset} from '@sanity/image-url/lib/types/types';

export default function MobileGalleryCarousel({
  images,
}: {
  images: SanityAsset[];
}) {
  const [swiper, setSwiper] = useState<SwiperClass>({});

  useEffect(() => {
    setTimeout(() => {
      swiper?.slideTo?.(0);
    }, 10);
    // We don't want to re-run this effect when the swiper instance changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images]);

  return (
    <Swiper
      onSwiper={(s) => setSwiper(s)}
      // @ts-expect-error @headlessui/react
      modules={[Navigation, Pagination]}
      pagination={{
        clickable: true,
        horizontalClass: 'flex justify-center items-center p-4',
        bulletActiveClass: `!bg-black`,
        bulletClass: 'w-2 h-2 rounded mx-1 inline-block bg-gray-250',
      }}
      className={'relative'}
      slidesPerView={'auto'}
      spaceBetween={10}
      effect="fade"
      shortSwipes={true}
      threshold={10}
      allowTouchMove={true}
    >
      {images?.map((med, index) => (
        <SwiperSlide
          // @ts-ignore
          key={med?.asset?._ref}
          style={{
            width: 'calc(100vw - 40px)',
          }}
        >
          <div className="h-full">
            <SanityImage
              alt={`gallery ${index}`}
              dataset={sanityConfig.dataset}
              layout="responsive"
              projectId={sanityConfig.projectId}
              src={med?.asset?._ref}
              className="rounded-[10px] lg:rounded-none object-contain h-[399px] md:h-[802px]"
              breakpoints={[
                [360, 180],
                [480, 240],
                [906, 460],
              ]}
              disableFitCrop
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
